"use strict";

// Vendor dependencies
import "bootstrap";

import scrollClassHeader from "./modules/scroll-class-header.js";
import articlesCarousel from "./modules/articles-carousel.js";

$(document).ready(function() {
  scrollClassHeader();
  articlesCarousel();

  // Init AOS animation library
  AOS.init();
});
